import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Box, Paper, Typography } from "@mui/material";

import SignUpComponent from "../../components/auth/SignUp";
import GoogleAuth from "../../components/auth/GoogleAuth";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignUp() {
  return (
    <React.Fragment>
      <Helmet title="Sign up" />
      <img
        src="/static/img/brands/logo.svg"
        width={220}
        height={64}
        alt="logo-opensacler"
        style={{ marginBottom: 8 }}
      />
      <Wrapper>
        <Typography
          component="h1"
          variant="h4"
          align="center"
          gutterBottom
          mb={8}
        >
          Create your account
        </Typography>
        <SignUpComponent />
        <GoogleAuth />
      </Wrapper>
      <Box sx={{ position: "absolute", bottom: 16 }}>
        <Typography mx={4}>
          © 2022 - OpenScaler Cloud Computer Technology Platform ** MVP **
        </Typography>
      </Box>
    </React.Fragment>
  );
}

export default SignUp;
